import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import FormEdit from '../../../../components/auth/atos/listar/form_edit'
import Head from '../../../../components/head'


function EditarAtosScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Ato Oficial do Governo" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarAtosScreen;